/**
 * Food & Beverages alt kategorileri — public/icons/food-subcategories/*.svg
 * Anahtarlar ürün / SUBMENU `key` ile birebir eşleşir.
 */
const B = '/icons/food-subcategories';
const ICON_CACHE_VER = '2';

/** @type {Record<string, string>} */
export const FOOD_SUBCATEGORY_SVG_BY_KEY = {
  Pasta: `${B}/pasta.svg`,
  'Wheat Flour': `${B}/flour_17549896.svg`,
  'Edible Oils': `${B}/sunflower-oil.svg`,
  'Sunflower Oil': `${B}/sunflower-oil.svg`,
  'Olive Oil': `${B}/sunflower-oil.svg`,
  Bulgur: `${B}/bulgur.svg`,
  Semolina: `${B}/semolina.svg`,
  'Energy Drink': `${B}/energy-drink_3789863.svg`,
  '100% Juice': `${B}/fruit-juice_1719761.svg`,
  'Tomato Paste': `${B}/tomato-paste.svg`,
  Candy: `${B}/confectionery.svg`,
  'Roasted Eggplant': `${B}/eggplant_381053.svg`,
  'Grape Leaves': `${B}/grape_4977139.svg`,
  Pickles: `${B}/pickle_3387938.svg`,
  'Stuffed Grape Leaves': `${B}/dolma.svg`,
  'Dried Fruits': `${B}/dried-fruits.svg`,
  'Iced Coffee': `${B}/ice-coffee_5071689.svg`,
  'Ice Coffee': `${B}/ice-coffee_5071689.svg`,
  Jams: `${B}/jam.svg`,
  'Mineral Water': `${B}/mineral-water_6531328.svg`,
  Noodle: `${B}/noodle_4853311.svg`,
  'Roasted Red Pepper': `${B}/roasted-red-pepper_3813064.svg`,
  Salt: `${B}/salt_3582471.svg`,
  'Organic Juice': `${B}/fruit-juice_1719761.svg`,
  'Fruit Drink': `${B}/fruit-juice_1719761.svg`,
  Nectar: `${B}/fruit-juice_1719761.svg`,
  Chocolate: `${B}/confectionery.svg`,
  'Biscuit & Cookies': `${B}/confectionery.svg`,
  'Chips & Corn Flakes': `${B}/confectionery.svg`,
  'Chewing Gum': `${B}/confectionery.svg`,
  Confectionery: `${B}/confectionery.svg`,
  'Fruit Juices': `${B}/fruit-juice_1719761.svg`,
  'Fresh Vegetables & Fruits': `${B}/pickle_3387938.svg`,
};

/**
 * @param {string} subKey SUBMENU veya ürün `subcategory` anahtarı
 * @returns {string | null}
 */
export function getFoodSubcategorySvgSrc(subKey) {
  const k = (subKey || '').trim();
  const src = FOOD_SUBCATEGORY_SVG_BY_KEY[k];
  if (!src) return null;
  return `${src}?v=${ICON_CACHE_VER}`;
}
